const MENU_ITEM_MANAGE_USERS = 'MENU_ITEM_MANAGE_USERS';
const MENU_ITEM_REPORT_GLOBAL = 'MENU_ITEM_REPORT_GLOBAL';
const MENU_ITEM_USERS_REPORT_ACCESS = 'MENU_ITEM_USERS_REPORT_ACCESS';

const defaultState = {
    manageUsersEnabled: false,
    globalReportsEnabled: false,
    userReportsEnabled: false
}

export const sidebarItems = (state = defaultState, action: any) => {

    if(action.type === MENU_ITEM_MANAGE_USERS) {
        state = {
            ...state,
            manageUsersEnabled: action.payload
        }
        return state;
    }
    else if(action.type === MENU_ITEM_REPORT_GLOBAL) {
        state = {
            ...state,
            globalReportsEnabled: action.payload
        }
        return state;
    } else if(action.type === MENU_ITEM_USERS_REPORT_ACCESS) {
        state = {
            ...state,
            userReportsEnabled: action.payload
        }
        return state;
    } else {
        return state;
    }
}